import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api';

export interface HospitalReportsParams {
  month?: string;
  startMonth?: string;
  endMonth?: string;
  reportTypeCode?: string;
  status?: string;
}

export function useHospitalReports(params: HospitalReportsParams = {}) {
  return useQuery({
    queryKey: ['admin', 'hospital-reports', params],
    queryFn: async () => {
      const { data } = await adminApi.getHospitalReports(params);
      return data;
    },
  });
}
